import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { checkPermList, classNames as cn } from 'helpers'
import st from './MultiActionMenu.module.scss'
import { ReactComponent as MoreIcon } from 'components/UI/ActionMenu/more-2-line.svg'
import { Link } from 'react-router-dom'
import { ReactComponent as ArrowIcon } from 'components/UI/icons/arrow-down-s-line.svg'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'

export const checkActionPermission = (perm) => {
  if (perm) {
    if (Array.isArray(perm)) {
      return !!perm.some((p) => checkPermList(p))
    } else {
      return !!checkPermList(perm)
    }
  } else {
    return true
  }
}

const MultiActionMenu = (props) => {
  const [open, setOpen] = useState(false)
  const refButton = useRef(null)
  const isArrowIcon = props.iconType === 'arrow'

  const clickClack = (action, e, items, line) => {
    setOpen(false)
    props.action(action, e, items, line)
  }

  useEffect(() => {
    if (open)
      document.body.addEventListener(
        'click',
        ({ target }) => {
          if (!refButton.current.contains(target)) setOpen(false)
        },
        { once: true },
      )
  }, [open])

  const renderAction = (action, index) => {
    const key = index
    let actionStyle = st.actionItem
    if (props.sortOrder[action.action] === true) {
      actionStyle = st.actionSortOrder
    }

    if (action.title) {
      return (
        <span key={key} className={st.title}>
          <p className={st.title__name}>{action.title}</p>
        </span>
      )
    } else if (action.line === true) {
      return <span key={key} className={st.title__line}></span>
    } else if (action.checkbox) {
      return (
        <div key={key} className={st.title}>
          <div className={st.title__name}>
            <ToggleCheckbox
              key={`checkbox-${key}`}
              label={action.checkbox.label}
              checked={action.checkbox.value}
              onChange={action.checkbox.onChange}
            />
          </div>
        </div>
      )
    } else {
      return checkActionPermission(action.permission) ? (
        action.link ? (
          <Link key={key} to={action.link.to} target={action.link.target}>
            {action.name}
          </Link>
        ) : (
          <div
            className={actionStyle}
            key={key}
            onClick={(e) => clickClack(action.action, e, props.items, action)}
          >
            {action.name}
          </div>
        )
      ) : null
    }
  }

  return (
    <div className={`${st.actionMenu} ${props.className || ''}`}>
      <div
        className={`${st.button} ${open ? st.buttonActive : ''} ${isArrowIcon ? st.buttonArrowIcon : ''}`}
        onClick={() => setOpen(!open)}
        ref={refButton}
      >
        {isArrowIcon ? (
          <ArrowIcon />
        ) : (
          <MoreIcon
            className={cn({
              [st.moreIcon]: true,
              [st.moreIconActive]: open,
            })}
          />
        )}
      </div>
      <div
        className={cn({
          [st.modal]: true,
          [st.modalArrowType]: isArrowIcon && open,
          [st.modalOpen]: open,
          [st.modalClose]: !open,
        })}
      >
        <div className={`${st.menu} ${isArrowIcon ? st.arrowTypeMenu : ''}`}>
          {props.menu.map(renderAction)}
        </div>
      </div>
    </div>
  )
}

MultiActionMenu.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  action: PropTypes.func,
}

export default MultiActionMenu
